import { render, staticRenderFns } from "./m-editStatementAnswer.vue?vue&type=template&id=fe1fc6f2&"
import script from "./m-editStatementAnswer.vue?vue&type=script&lang=js&"
export * from "./m-editStatementAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports